import { CdrBreakpointSm as e, CdrBreakpointMd as n, CdrBreakpointLg as t } from "../../node_modules/@rei/cdr-tokens/dist/js/cdr-tokens.mjs";
function o() {
  const r = window && window.innerWidth || 0;
  return r >= e && r < n ? "sm" : r >= n && r < t ? "md" : r >= t ? "lg" : "xs";
}
export {
  o as default
};
